module.exports = __webpack_public_path__ + "img/NAPLES SQ PHASE 2.0f620bd2.png";